"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AutoFormContext = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _informed = require("informed");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("axios/index"));
var _excluded = ["url", "schemaMethod", "children"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AutoForm = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function AutoForm(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AutoForm);
    _this = _callSuper(this, AutoForm, [props]);
    _this.state = {
      loading: true,
      schema: null
    };
    return _this;
  }
  (0, _inherits2["default"])(AutoForm, _React$Component);
  return (0, _createClass2["default"])(AutoForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.props.url) {
        return;
      }
      (0, _index["default"])({
        method: 'OPTIONS',
        url: this.props.url
      }).then(function (response) {
        _this2.setState({
          loading: false,
          schema: response.data.actions[_this2.props.schemaMethod]
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return null;
      }
      var _this$props = this.props,
        url = _this$props.url,
        schemaMethod = _this$props.schemaMethod,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_informed.Form, rest, /*#__PURE__*/_react["default"].createElement(AutoFormContext.Provider, {
        value: this.state.schema
      }, children));
    }
  }]);
}(_react["default"].Component);
var AutoFormContext = exports.AutoFormContext = /*#__PURE__*/_react["default"].createContext();
AutoForm.propTypes = {
  url: _propTypes["default"].string.isRequired,
  schemaMethod: _propTypes["default"].string
};
AutoForm.defaultProps = {
  schemaMethod: 'POST'
};